import { gql } from '@apollo/client';

export const GET_OFFER_CODE_DETAILS = gql`
  query GetOfferCodeDetails($code: String!) {
    getOfferCodeDetails(code: $code) {
      code
      offerName
      offerDescription
      packageName
      packageCode
      offerType
      accessDurationDays
      billingCycle
      expiresAt
      isValid
      error
    }
  }
`;

export const VALIDATE_OFFER_CODE = gql`
  query ValidateOfferCode($code: String!) {
    validateOfferCode(code: $code) {
      code
      offerName
      offerDescription
      packageName
      packageCode
      offerType
      accessDurationDays
      billingCycle
      expiresAt
      isValid
      error
    }
  }
`;

export const REDEEM_OFFER_CODE = gql`
  mutation RedeemOfferCode($code: String!) {
    redeemOfferCode(code: $code) {
      success
      offerType
      packageCode
      packageName
      accessDurationDays
      checkoutUrl
      error
    }
  }
`;
